// src/config/wsAccountCheckerConfig.js (New File)

export const WS_ACCOUNT_CHECKER_TYPES = {
  // Client -> Server
  START_CHECK: 'ACCOUNT_CHECK_START',
  CANCEL_CHECK: 'ACCOUNT_CHECK_CANCEL',
  GET_HISTORY: 'ACCOUNT_CHECK_GET_HISTORY',
  GET_RECENT_SEARCHES: 'ACCOUNT_CHECK_GET_RECENT_SEARCHES',

  // Server -> Client
  CHECK_INITIATED: 'ACCOUNT_CHECK_INITIATED',
  CHECK_PROGRESS: 'ACCOUNT_CHECK_PROGRESS',
  CHECK_RESULT: 'ACCOUNT_CHECK_RESULT',
  CHECK_BATCH_RESULT: 'ACCOUNT_CHECK_BATCH_RESULT',
  CHECK_NO_RESULTS: 'ACCOUNT_CHECK_NO_RESULTS',
  CHECK_COMPLETED: 'ACCOUNT_CHECK_COMPLETED',
  CHECK_ERROR: 'ACCOUNT_CHECK_ERROR',
  HISTORY_LIST: 'ACCOUNT_CHECK_HISTORY_LIST',
  HISTORY_ERROR: 'ACCOUNT_CHECK_HISTORY_ERROR',
  RECENT_SEARCHES_LIST: 'ACCOUNT_CHECK_RECENT_SEARCHES_LIST',
};

export const WS_ACCOUNT_CHECKER_TOPICS = {
  // Client commands (Frontend -> Backend)
  APP_ENDPOINT: '/account-checker',
  APP_GET_HISTORY: '/get-history',
  APP_GET_RECENT_SEARCHES: '/get-recent-searches',

  // User-specific destinations (Backend -> Frontend)
  USER_QUEUE_BASE: '/user/queue/account-checker',
  RESULTS: '/results',
  ERRORS: '/errors',
  USER_HISTORY: '/history',
  USER_RECENT_SEARCHES: '/recent-searches',

  // Public Topics for Broadcasting (Backend -> All Connected Clients)
  PUBLIC_TOPIC_BASE: '/topic/account-checker',
  PUBLIC_RECENT_SEARCHES: '/recent-searches',
};

export const getAccountCheckerAppEndpoint = (action) => `${WS_ACCOUNT_CHECKER_TOPICS.APP_ENDPOINT}${action}`;
export const getAccountCheckerUserQueueTopic = (subTopic) => `${WS_ACCOUNT_CHECKER_TOPICS.USER_QUEUE_BASE}${subTopic}`;
export const getAccountCheckerPublicTopic = (subTopic) => `${WS_ACCOUNT_CHECKER_TOPICS.PUBLIC_TOPIC_BASE}${subTopic}`;